export default __webpack_public_path__ + "static/media/markdown.62e50cf0.svg";